import { render } from "./group.vue?vue&type=template&id=6ca34b12&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"

import "./group.vue?vue&type=style&index=0&id=6ca34b12&lang=scss&scoped=true"

import exportComponent from "/home/forge/app-ticket.grandigiardini.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca34b12"]])

export default __exports__